import React from 'react';
import {Link} from "react-scroll";
import HeroImage from '../assets/heroImage.png';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
const Home = () => {
  return (
    <div name="home" className='h-screen w-full 
    bg-gradient-to-b from-black via-black to-gray-800 '>
      <div className='max-w-screen-lg mx-auto flex flex-col
      items-center justify-center h-full px-4 md:flex-row'>
        <div className='flex flex-col justify-center h-full'>
            <h2 className='text-4xl sm:text-7xl font-bold text-white'>
                I'm a Full Stack Developer :)
            </h2>
            <p className='text-gray-500 py-4 max-w-md'>
                I'm a developer, holding a master degree in 
                computer science.
                I'm  very passoinate about learning new technologies.
                I actually find fun and enjoyment when I learn something
                new and code those things.
                Currently, I worked in technologies like react,tailwind,Material UI,
                Next Js continue.....
            </p>
            <div>
                <Link to="projects" smooth duration={500} className='group text-white w-fit
                px-6 py-3 my-2 flex items-center rounded-md 
                bg-gradient-to-r from-cyan-500 to-blue-800
                cursor-pointer'>
                    Projects
                    <span className='group-hover:rotate-90 duration-300'>
                        < MdOutlineKeyboardArrowRight size={25}
                        className='ml-1'/>
                    </span>
                </Link>
            </div>
        </div>
        <div>
            <img src={HeroImage} alt="my profile" 
            className='rounded-2xl mx-auto w-2/3 md:w-full '/>
        </div>
      </div>
    </div>
  )
}

export default Home
